module.exports = __webpack_public_path__ + "static/media/politica-ambiental-banner.c3cd238d.png";